module.exports = __webpack_public_path__ + "static/go-sign-a30cf27343b831e54d073abdde167369.png";